import { Injectable, Inject } from 'ng-metadata/core';
import {ALERT_MSG_TYPE, AlertFactory} from "../../../../infra/widgets/alerts/alertFactory.service";
import {IGeneralAlertMsg} from "../../../../infra/widgets/alerts/alertMsg.interface";
import {MappingTablesCache} from '../../../../mappingTablesCache/mappingTablesCache.service'
@Injectable()
export class ViewItService {

    private htmlRegex =/(<([^>]+)>)/ig;
    private brHtmlTagRegex = /<br>/gi;
    private htmlSpaceRegex =/&nbsp;/ig;
    private _reqAlert :IGeneralAlertMsg;
    // There is a meaning to the order of the services in the list.
    // The order is determined by the order of the services in the list unless it is changed by setServicesListOrder().
    private servicesList = [
        {name: 'ELECTRONIC', header: 'viewit.fulltext', subHeader: ''},
        {name: 'ELECTRONIC_RELATED', header: 'viewit.fulltext', subHeader: 'c.uresolverServicesForRelatedTitles'},
        {name: 'GENERAL_ELECTRONIC', header: 'c.uresolver.GeneralElectronicServices', subHeader: ''},
        {name: 'DIGITAL', header: 'ui.viewit.digital_version', subHeader: ''},
        {name: 'DIGITAL_RELATED', header: 'ui.viewit.digital_version', subHeader: 'c.uresolverServicesForRelatedTitles'},
        {name: 'ESPLORO', header: '', subHeader: ''}];

    constructor(@Inject('$http') private $http : ng.IHttpService,
                private alertFactory :AlertFactory,
                private mappingTablesCache: MappingTablesCache) {
        this._reqAlert = this.alertFactory.create(ALERT_MSG_TYPE.REQUEST) as IGeneralAlertMsg;
        this.setServicesListOrder();
    }

    public setReqAlert(isLoggedIn, label){
        let html = '';
        if(label){
            html = '<span class="bar-text margin-right-small" translate="' + label + '"></span>';
            if(!isLoggedIn){
                html += '<prm-authentication [is-logged-in]="ctrl.userName().length > 0" flex="none"></prm-authentication>';
            }
        }
        this._reqAlert.show(html);
    }

    private setServicesListOrder(){
        let eBeforeD = true;
        let row =  this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.ALMA_VIEWIT_CONFIG,
                                    {target: 'electronic_services_before_digital'});
            if(row && row.length > 0){
             if(row[0].source1 !== 'true'){
                 eBeforeD = false;
             }
            }
            if(!eBeforeD){
                // Find the indices of 'DIGITAL' and 'DIGITAL_RELATED'
                let digitalIndex = this.servicesList.findIndex(service => service.name === 'DIGITAL');
                let digitalRelatedIndex = this.servicesList.findIndex(service => service.name === 'DIGITAL_RELATED');
                // Remove 'DIGITAL' and 'DIGITAL_RELATED' from the array
                let digitalService = this.servicesList.splice(digitalIndex, 1)[0];
                let digitalRelatedService = this.servicesList.splice(digitalRelatedIndex - 1, 1)[0];
                // Add 'DIGITAL' and 'DIGITAL_RELATED' back to the beginning of the array
                this.servicesList.unshift(digitalRelatedService);
                this.servicesList.unshift(digitalService);
            }

    }

    public getLicense(item){
        if(item.licence){
            return;
        }
        if(!item.licenceUrl){
            return '';
        }
        let httpConfig = {
                method: 'GET',
                url: item.licenceUrl,
                params:  null,
                data:  null
        };

        this.$http(httpConfig)
        .then(
                (response)=> {
                    if(response && response.data && response.data.displayValue){
                        item.licence = this.splitHtml(response.data.displayValue);
                    }
                }
        );

    }
    public splitHtml(html){
        if(!html){
            return;
        }
        let splittedHtml = html.replace(this.brHtmlTagRegex,';;').replace(this.htmlSpaceRegex,'').split(';;');

        if(splittedHtml){
            splittedHtml = splittedHtml.filter(
                    (elm)=> elm && 0 !== elm.length);
        }
        return splittedHtml;
    }
    public stripHtml(html){
        if(!html){
            return;
        }
        return html.replace(this.htmlRegex,'').replace(this.htmlSpaceRegex,'');
    }

    get reqAlert() {
        return this._reqAlert;
    }

    public getServicesList(){
        return this.servicesList;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/almaViewit/almaViewit.service.ts